import React from 'react';
import PropTypes from 'prop-types';

const Transactions = ({ altText }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='1.5em' height='1.5em' fill='none'>
      <title id='transactions-title'>{altText}</title>
      <path fill='currentColor' fillRule='evenodd' d='M14.53 3.47a.75.75 0 1 0-1.06 1.06l.72.72H4.5A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25H5a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 1-.75-.75V9.75h.75A2.25 2.25 0 0 0 6.75 7.5v-.75h7.44l-.72.72a.75.75 0 0 0 1.06 1.06l2-2a.748.748 0 0 0 0-1.06l-2-2ZM4.5 6.75a.75.75 0 0 0-.75.75v.75h.75a.75.75 0 0 0 .75-.75v-.75H4.5ZM18.25 6a.75.75 0 0 1 .75-.75h.5a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25H9.81l.72.72a.75.75 0 1 1-1.06 1.06l-2-2a.748.748 0 0 1-.22-.528v-.004a.748.748 0 0 1 .22-.528l2-2a.75.75 0 1 1 1.06 1.06l-.72.72h7.44v-.75a2.25 2.25 0 0 1 2.25-2.25h.75V7.5a.75.75 0 0 0-.75-.75H19a.75.75 0 0 1-.75-.75Zm1.25 11.25h-.75v-.75a.75.75 0 0 1 .75-.75h.75v.75a.75.75 0 0 1-.75.75Z' clipRule='evenodd'/>
      <path fill='currentColor' fillRule='evenodd' d='M12 9.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5ZM10.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z' clipRule='evenodd'/>
    </svg>
  );
};

Transactions.propTypes = {
  altText: PropTypes.string
};

export default Transactions;
